/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineScopeTenant extends models.TagBaselineScope {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineScopeTenant");
    }

    getFixupPrototypeFunction() { return TagBaselineScopeTenant.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineScopeTenant>): TagBaselineScopeTenant {
        let obj = Object.assign(new TagBaselineScopeTenant(), model);
        TagBaselineScopeTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineScopeTenant>): TagBaselineScopeTenant {
        if (!model) return null;
        return TagBaselineScopeTenant.newInstance(<TagBaselineScopeTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineScopeTenant) {
        if (!obj) return;

        models.TagBaselineScopeTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineScopeTenant): boolean {
        if (models.TagBaselineScope.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineScopeTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    tenant_ids: Array<string>;

}
